import axios from "axios";
import { backendURL } from "../url";
import { AdminCustomer, HearAboutUsStats } from "../schemas/user";

const API_URL = "/api/user";

export const getUserDetails = async () => {
  const userId = localStorage.getItem("userId");
  try {
    const response = await axios.get(
      `${backendURL}${API_URL}/user-detail/${userId}`
      // `${process.env.REACT_APP_BACKEND_URL}${API_URL}/user-detail/${userId}`
    );
    return response.data.userDetail;
  } catch (error) {
    console.error(error);
    return null;
  }
};

export const getUserByEmail = async (email: string) => {
  const token = localStorage.getItem("token");
  try {
    const response = await axios.get(
      `${backendURL}${API_URL}/user-by-email/${email}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data.user;
  } catch (error) {
    console.error(error);
    return null;
  }
};

export const getAllUsers = async () => {
  const token = localStorage.getItem("token");
  try {
    const response = await axios.get(
      `${backendURL}${API_URL}/users`,
      // `${process.env.REACT_APP_BACKEND_URL}${API_URL}/users`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data.userDetails;
  } catch (error) {
    console.error(error);
    return [];
  }
}

export const updateUser = async (id: string, data: any) => {
  const token = localStorage.getItem("token");
  try {
    const response = await axios.put(`${backendURL}${API_URL}/update-user/${id}`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error(error);
    return null;
  }
}

export const getHearAboutUsStats = async (params?: {
  startDate?: string;
  endDate?: string;
}): Promise<HearAboutUsStats> => {
  const token = localStorage.getItem("token");
  const response = await axios.get(`${backendURL}${API_URL}/hear-about-us-stats`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
    params: {
      ...(params?.startDate ? { startDate: params.startDate } : {}),
      ...(params?.endDate ? { endDate: params.endDate } : {}),
    },
  });
  return response.data;
};

export const getAdminCustomers = async (): Promise<AdminCustomer[]> => {
  const token = localStorage.getItem("token");
  const response = await axios.get(`${backendURL}${API_URL}/admin/customers`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data.customers;
};

export const getAdminCustomerById = async (id: string): Promise<AdminCustomer> => {
  const token = localStorage.getItem("token");
  const response = await axios.get(
    `${backendURL}${API_URL}/admin/customers/${id}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return response.data.customer;
};

export const unsubscribePromotions = async (token: string) => {
  const response = await axios.post(
    `${backendURL}${API_URL}/unsubscribe-promotions`,
    { token }
  );
  return response.data as { message: string };
};

export const updateAdminCustomer = async (
  id: string,
  data: {
    firstName: string;
    lastName: string;
    email: string;
    phoneNumber: string;
    address: string;
    password?: string;
  }
) => {
  const token = localStorage.getItem("token");
  const response = await axios.put(
    `${backendURL}${API_URL}/admin/customers/${id}`,
    data,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return response.data;
};